export const SET_ADDRESSES = "SET_ADDRESSES";
export const SET_EMAIL_ADDRESSES = "SET_EMAIL_ADDRESSES";

export function setAddresses(addresses) {
    return {
        type: SET_ADDRESSES,
        addresses
    };
}

export function setEmailAddresses(emailAddresses) {
    return {
        type: SET_EMAIL_ADDRESSES,
        emailAddresses
    };
}
